import { createContext, useContext, useReducer } from 'react';
import ajaxStat from '../util/remote/ajaxStat';

const initialState = { 
    profitLoss : null,
    topExpenses : null,
    netWorth : null,
    creditorInvoicing : null,
    projectStatList : null,
    loadingProjectStatList: false,
    income: 0,
    expense: 0,
    net: 0,
    dateRange: {"opening_date": "", "closing_date": ""},
};

const reducer = (state, action) => {

  switch (action.type) {
    case 'CLEAR':
      return { initialState};  // Reset state completely
    default:
      return {...state, [action.type]: action.payload};
  }

};


const StatContext = createContext();

export const StatProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);

 
  const getProfitLoss=async(refresh = false)=>{
    if(state.profitLoss && !refresh) return; // already loaded
    const server_response = await ajaxStat.fetchProfitLoss(state.dateRange);
    if(server_response.status==="OK"){
        dispatch({ type: 'profitLoss', payload: server_response.details });
        dispatch({ type: 'income', payload: server_response.details.income });
        dispatch({ type: 'expense', payload: server_response.details.expense });
        dispatch({ type: 'net', payload: server_response.details.net });
    }
  }  
  
  const getTopExpenses = async(refresh = false)=>{
    if(state.topExpenses && !refresh) return;
    const server_response = await ajaxStat.fetchTopExpenses(state.dateRange);
    if(server_response.status === "OK"){
      dispatch({type: 'topExpenses', payload: server_response.details})
    }
  }

  const getNetWorth = async(refresh = false) =>{
    if(state.netWorth && !refresh) return;
    const server_response = await ajaxStat.fetchNetWorth(state.dateRange);
    if(server_response.status === "OK"){
      dispatch({type: 'netWorth', payload: server_response.details})
    }
  }

  const getCreditorInvoicing = async(refresh = false) =>{
    if(state.creditorInvoicing && !refresh) return;
    const server_response = await ajaxStat.fetchCreditorInvoicing(state.dateRange);
    if(server_response.status === "OK"){
      dispatch({type: 'creditorInvoicing', payload: server_response.details})
    }
  }

  const getProjectStatList = async(refresh = false) =>{
    if(state.projectStatList && !refresh) return;
    dispatch({type: 'loadingProjectStatList', payload: true})
    const server_response = await ajaxStat.fetchProjectStatList(state.dateRange);
    dispatch({type: 'loadingProjectStatList', payload: false})
    if(server_response.status === "OK"){
      dispatch({type: 'projectStatList', payload: server_response.details})
    }
  }
 
    const refresh = async() =>{
        await getProfitLoss();
        await getTopExpenses();
        await getNetWorth();
        await getCreditorInvoicing();
        await getProjectStatList();
    }

  return(
    <StatContext.Provider value={{
      ...state, 
      dispatch, 
      getProfitLoss,
      getTopExpenses,
      getNetWorth,
      getCreditorInvoicing,
      getProjectStatList,
      refresh,
      }}>
      {children}
    </StatContext.Provider>
  )

}

export const useStat = ()=>useContext(StatContext);

